import { CopyField, InlineNotice } from "@bafe/ui";

export interface SecretOnceProps {
	title: string;
	value: string;
	label: string;
	/** What the customer should do with it before leaving the page. */
	instruction?: string;
}

/**
 * A credential Key cannot show again.
 *
 * Passwords are stored only as verifiers, so the warning is a statement of
 * fact rather than a policy choice.
 */
export function SecretOnce({ title, value, label, instruction }: SecretOnceProps) {
	return (
		<div className="flex flex-col gap-3">
			<div className="flex flex-col gap-1">
				<p className="text-sm font-medium text-(--text-primary)">{title}</p>
				<p className="text-sm text-(--text-secondary)">
					{instruction ?? "Copy it now and store it in your password manager."}
				</p>
			</div>

			<CopyField value={value} label={label} />

			<InlineNotice tone="caution" title="This will not be shown again">
				Key stores passwords in a form it cannot reverse. If you lose this one, you can set a new password,
				but you cannot recover this one.
			</InlineNotice>
		</div>
	);
}
